// forceFieldColor.js
var ForceFieldColor = pc.createScript('forceFieldColor');

ForceFieldColor.attributes.add('colorGrad', {type: 'curve', color: 'rgba'});


// initialize code called once per entity
ForceFieldColor.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    this.randomColor = null;

    this.mat1 = this.entity.children[0].model.meshInstances[1].material;
    this.mat2 = this.entity.children[0].model.meshInstances[2].material;
    this.mat3 = this.entity.children[0].model.meshInstances[3].material;
    this.colorize();
};

ForceFieldColor.prototype.colorize = function(){
    //console.info(this.entity.children[0].model.meshInstances[1].material);
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed);
    var cg = this.colorGrad;
    var cr = this.randomize();
    var rc = new pc.Color(cg.get(0).value(cr), cg.get(1).value(cr), cg.get(2).value(cr));
    this.mat1.emissive = rc;
    this.mat2.emissive = rc;
    this.mat3.emissive = rc;
    this.mat1.update();
    this.mat2.update();
    this.mat3.update();

    
};

// update code called every frame
ForceFieldColor.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// ForceFieldColor.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

